import styled from 'styled-components';
import { Loader as LoaderComponent } from '@playbookux/playbook-web-core';

const PreviewStudyContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${({ noMargin }) => (noMargin ? '0px' : '20px')};
`;

const PreviewStudy = styled.a`
  align-items: center;
  display: flex;
  color: ${(props) => (props.disabled ? 'gray' : '')};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`;

const PreviewStudyIcon = styled.img`
  width: 15px;
  margin-right: 4px;
`;

const Loader = styled(LoaderComponent).attrs(() => ({
  size: 'mini',
}))`
  &&& {
    margin: 5px;
  }
`;

export {
  PreviewStudyContainer,
  PreviewStudyIcon,
  PreviewStudy,
  Loader,
};
